import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Console-only debug logging (no on-screen UI): surface uncaught errors and
// unhandled rejections with full stacks so prod issues are easy to spot in the
// browser console. Empty-reason rejections (benign realtime/websocket blips) are
// swallowed + throttled so they never flood and hide real errors.
{
  let emptyRejections = 0
  window.addEventListener('error', (e) =>
    // eslint-disable-next-line no-console
    console.error('[cordite] error:', e.error ?? e.message),
  )
  window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
    const r: any = e.reason
    if (r === undefined || r === null) {
      e.preventDefault()
      // eslint-disable-next-line no-console
      if (++emptyRejections % 100 === 1) console.debug(`[cordite] suppressed ${emptyRejections} empty rejection(s) (realtime/ws blips)`)
      return
    }
    // eslint-disable-next-line no-console
    console.error('[cordite] unhandledrejection:', r)
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
